import {
    IQueryString,
    LocationPickerSelection,
    objToQueryString
} from '../../../shared/models';

export class ProductFilter implements IQueryString {
     constructor(
        public name: string,
        public locationsSelection?: LocationPickerSelection,
        public inStock?: boolean,
        public outStock?: boolean) {}

    toQueryString() {
        let payload = {
            name: this.name,
            instock: this.inStock,
            outStock: this.outStock
        };

        this.locationsSelection = this.locationsSelection || new LocationPickerSelection();

        return `${objToQueryString(payload)}${this.locationsSelection.toQueryString()}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/product-filter.ts